import React from 'react';
import { Link } from 'react-router-dom';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const ContextAuthorCard = ({ author }) => (
  <Link to={author.absolute_url}>
    <div className="billetContainer">
      <div className={styles.author}>
        <div className={styles.authorBlock}>
          <CroppedImage
            className={styles.authorImage}
            width={40}
            height={40}
            src={author.photo}
            alt={author.cover_name} />
          <div className={styles.authorInfo}>
            <div className={styles.authorName}>
              <big>
                <span className="link">{author.cover_name}</span>
              </big>
            </div>
            <div className={styles.authorBookCount}>
              {`${author.active_book_count} ` +
                `${pluralize(author.active_book_count, 'книга', 'книги', 'книг')}`}
            </div>
          </div>
        </div>
        <div className="shortArrow" />
      </div>
    </div>
  </Link>
);

export default ContextAuthorCard;
